import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useOffer } from "@/lib/offer";
import { useLanguage } from "@/lib/i18n";
import "./LaunchOfferBanner.css";

/** Grand Launch Offer strip — emerald/ivory/gold, shown only while the offer is active. */
export default function LaunchOfferBanner() {
  const { t } = useLanguage();
  const offer = useOffer();
  if (!offer || !offer.active) return null;
  return (
    <motion.section
      className="launch-banner"
      data-testid="launch-offer-banner"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="launch-banner-inner">
        <span className="launch-banner-eyebrow" data-testid="launch-offer-eyebrow">
          {t("Grand Launch Offer")}
        </span>
        <p className="launch-banner-title">
          {t("20% off profile registration")}
          <span className="launch-banner-prices">
            <s data-testid="launch-offer-old-price">₹{offer.original}</s>
            <strong data-testid="launch-offer-price">₹{offer.final}</strong>
          </span>
        </p>
        <span className="launch-banner-dates" data-testid="launch-offer-dates">
          {t("Valid 25 Oct – 24 Nov 2026")}
        </span>
        <Link to="/register" className="launch-banner-cta" data-testid="launch-offer-cta">
          {t("Create Profile")}
        </Link>
      </div>
    </motion.section>
  );
}
